<template>
    <div id="gwap-body" ref="gwapElement">
        <BlockFrame :header="{ title: appletData.name, icon: appletData.icon, more: true, code: 'mySendcar' }">
            <div class="box">
                <div v-for="item in imgData" :key="item.id" class="content">
                    <div class="left" style="display: flex; width: 200px; align-items: center">
                        <div style="width: 100px; height: 70px">
                            <img v-if="appletData.interfaceStatus === 0 || openInterface" style="width: 100%; height: 100%; object-fit: cover" src="../imgs/che.png" alt="" />
                            <img v-else style="width: 100%; height: 100%; object-fit: cover" :src="base_api + '/clgl/clxx/download?dataField=carPhoto&nameField=fileName&id=' + item.id" alt="" />
                        </div>
                        <div style="line-height: 24px; padding-left: 10px">
                            <div style="color: #333; font-size: var(--portalFontSize14)">{{ item.carModel }}</div>
                            <div>{{ item.carNumber }}</div>
                        </div>
                    </div>
                    <div v-text-lbl="'seat'" class="center" :num="item.totalPassenger">{{ item.totalPassenger }}座</div>
                    <div class="right">
                        <el-button v-if="item.passenger.homeStatus !== 2 && item.passenger.homeStatus !== 3" v-pageBtn-lbl="'usingCar'" style="background: #48ba79; color: #fff" @click="apply('ycsq', '用车申请', '', 'clgl/ycsq', item.carNumber, item.carType)">用车</el-button>
                        <el-button v-else v-pageBtn-lbl="'usingCar'" disabled type="info">用车</el-button>
                    </div>
                </div>
            </div>
        </BlockFrame>
    </div>
</template>

<script>
const moment = require('moment')
import { mapGetters } from 'vuex'

export default {
    // import引入的组件需要注入到对象中才能使用
    name: 'Gwap',
    props: {
        title: { type: String, default: '' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'clgl',
            moduleCode: 'portlet',
            markDate: '',
            loading: true,
            listdata: [],
            allData: [],
            loginUser: this.$store.getters.loginUser,
            pages: '',
            base_api: process.env.VUE_APP_BASE_API,
            showDialog: false,
            vo: {},
            activeDate: moment(new Date()).format('YYYY/MM/DD'),
            value1: [],
            imgData: [],
            pageTotal: 0,
            openInterface: window.openInterface
        }
    },
    computed: {
        ...mapGetters(['routes', 'loginUser'])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$options.components['BlockFrame'] = this.$loadComponent('@/wapp/common/components/BlockFrame/index')
        const now = moment().format('YYYY-MM-DD HH:mm:ss')
        const tow = moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        this.value1 = [now, tow]
        this.base_api = process.env.VUE_APP_BASE_API
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
        this.title = this.title || this.$tx('clgl.portlet.gwap', '公务安排')
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {
        // 申请用车
        apply(code, name, start, wfEngineUrl, carNumber, carType) {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                this.$bus.emit('openDefaultDialog', this.appletData.name)
                return
            }
            let href = '/wflow?busiCode=' + code + '&wfName=' + encodeURI(name) + '&startNodeName=' + start + '&carNumber=' + carNumber + '&carType=' + carType
            href += '&wfEngineUrl=' + encodeURIComponent(wfEngineUrl)
            window.open('/#' + href)
        },

        // 获取车辆数据
        async getData() {
            // 是否开启伪数据
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                const list = await this.$getDefaultData(this, this.appletData.id)
                this.imgData = list
                // this.nullProcessing('value', this.appletData.icon, this.position)
                return
            }
            const param = {
                pageNum: 1,
                pageSize: 4,
                urlsearch: `orgCode:${this.loginUser.orgCode};status!:3,9`,
                orderBy: 'carNumber asc',
                startDate: this.value1[0],
                endDate: this.value1[1]
            }
            const res = await this.$app.listdata('clgl/clxx/listdataAndStatus', param)
            if (res.code === 'success') {
                this.imgData = res.body.pageInfo.list
                this.pageTotal = res.body.pageInfo.total
            }
        }
    }
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
#gwap-body {
    background-color: #fff;
    width: 100%;
    height: 101%;
    .gwapTitle {
        border-left: 4px solid #1989fa;
        padding: 3px 10px;
        margin: 10px;
        color: #000;
        font-weight: bold;
    }
    /deep/.el-input--prefix .el-input__inner {
        padding-left: 30px;
    }
    .box {
        padding: 10px 15px;
    }
    .content {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        height: 100px;
        line-height: 80px;
        // border-bottom: 1px solid #f2f2f2;
        border-bottom: 1px dashed #eff4fc;
    }
    .content:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }
}
</style>
